export const GET_CS_SALES = 'GET_CS_SALES';
export const GET_CS_SALES_REQUEST = 'GET_CS_SALES_REQUEST';

export const GET_CS_INVITES = 'GET_CS_INVITES';
export const GET_CS_INVITES_REQUEST = 'GET_CS_INVITES_REQUEST';
